import { useQuery } from "@apollo/client";
import React from "react";
import { Router } from "@reach/router";
import { Viewer } from "components/auth/types";
import { isPropertyFeatureEnabled } from "pages/dashboard/interests";

import { Feature, SidebarFilters, SidebarFiltersVariables } from "types/gql-types";
import InterestProfileSlideout from "pages/dashboard/interests-profile-slideout/components/slideout";
import { QUERY_SIDEBAR_FILTERS } from "pages/dashboard/interests/interests-sidebar/query";
import SlideoutEnabledContext from "./context";

interface Props {
  list?: string;
  path: string;
  viewer: Viewer;
}

const WaitlistUpdateContainer: React.FC<Props> = (props) => {
  if (!props.list) return <h4 className="text-center">No properties have opted into list updates.</h4>;
  const query = useQuery<
  SidebarFilters, SidebarFiltersVariables
  >(QUERY_SIDEBAR_FILTERS, { variables: { interestListIds: [props.list] } });

  const features = query.data?.interestListsById[0].property.features || [];

  const slideoutEnabled = isPropertyFeatureEnabled(features, Feature.INTEREST_PROFILE_SLIDEOUT);
  return <SlideoutEnabledContext.Provider value={{ slideoutEnabled }}>
    {props.children}
    {slideoutEnabled && (
      <Router primary={false}>
        <InterestProfileSlideout
          path="interests/:interestId/*"
          viewer={props.viewer}
          listId={props.list}
          sendFullAppToInterestsEnabled={false}
        />
        <InterestProfileSlideout
          path="contact/interests/:interestId/*"
          viewer={props.viewer}
          listId={props.list}
          sendFullAppToInterestsEnabled={false}
        />
        <InterestProfileSlideout
          path="process/:step/interests/:interestId/*"
          viewer={props.viewer}
          listId={props.list}
          sendFullAppToInterestsEnabled={false}
        />
      </Router>
    )}
  </SlideoutEnabledContext.Provider>;

};
export default WaitlistUpdateContainer;
